<script>
import { mapState, mapActions } from 'vuex';
import { LOAD_TEMPLATES } from '@/store/types/action-types';
import ItemBrowser from './_item-browser';

export default {
    name: 'template-browser',

    extends: ItemBrowser,

    data() {
        return {
            itemType: 'template',
            defaultItemImg: 'https://via.placeholder.com/150x225?text=template',
        };
    },

    computed: {
        ...mapState({
            templates: ({ page }) => page.templates,
        }),
    },

    methods: {
        ...mapActions({
            loadTemplates: LOAD_TEMPLATES,
        }),

        async loadItems() {
            await this.loadTemplates();
            this.items = this.templates.filter(val => val.name !== 'Page');
        },
    },
};
</script>
